import React from "react";

const FourOhFour: React.FC = () => (
  <h3
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }}
  >
    404 page not found
  </h3>
);

export default FourOhFour;
